module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAA7ElEQVQ4T+3TsUoDQRAG4P+fcCBY3gvcExzcbm3Awl4wdUqrPE8QS+uI6S1Ere+Ee4J7gSsDypn9w1mExJAELhFSOOUw++3u7A5xpKBzbgRgYGbsYoYQBGBC7/0XgAeSVRdIUgJg2EKS1C+K4r0LlGVZ38xeTwdyzl2QfDv4RP/Q/g/xJz0KAG4lfezff7OCZAbgvn3+JwDXXZCVNdOfQU2S5CyOY9uCjSUFku1wb0Rd16Gqqs/lxKdpeh5F0RXJ3mq1pJGkbzO7+5WfN03zXJblrM0vIe/9JYBHAGvQjivPAdzkef6yBh3YIywAewaS3rvWxRQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/public/img/shop1.png
// module id = ZLX6
// module chunks = 12